import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Navbar,
  MobileNav,
  Typography,
  Button,
  IconButton,
} from "@material-tailwind/react";
import { useTranslation } from "react-i18next";
import MessengerCustomerChat from "react-messenger-customer-chat";

export default function Example() {
  const navigate = useNavigate();

  const goContact = () => {
    navigate("/contact");
  };
  const goHome = () => {
    navigate("/home");
  };

  const { t, i18n } = useTranslation(["home"]);
  const [showButton, setShowButton] = useState(true);

  const onClickLanguageChange = (e: any) => {
    if (e === "en") {
      setShowButton(false);
    } else {
      setShowButton(true);
    }
    i18n.changeLanguage(e); //change the language
  };

  const [openNav, setOpenNav] = React.useState(false);

  React.useEffect(() => {
    window.addEventListener(
      "resize",
      () => window.innerWidth >= 960 && setOpenNav(false)
    );
  }, []);

  const navList = (
    <ul className="mb-4 mt-2 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6">
      <Typography
        as="li"
        variant="small"
        color="blue-gray"
        className="p-2 font-normal"
      >
        <a href="/home" className="flex items-center">
          {t("menu.home")}
        </a>
      </Typography>
      <Typography
        as="li"
        variant="small"
        color="blue-gray"
        className="p-2 font-normal"
      >
        <a href="/about" className="flex items-center">
          {t("menu.about")}
        </a>
      </Typography>
      <Typography
        as="li"
        variant="small"
        color="blue-gray"
        className="p-2 font-normal"
      >
        <a href="/service" className="flex items-center">
          {t("menu.service")}
        </a>
      </Typography>
    </ul>
  );

  return (
    <>
      <Navbar className="sticky inset-0 z-10 h-max max-w-full rounded-none py-2 px-4 lg:px-8 lg:py-4">
        <div className="flex items-center justify-between text-blue-gray-900">
          <img
            src={require("../assets/images/logo.png")}
            alt=""
            className=" object-right max-h-10 md:object-center"
            onClick={goHome}
          />
          <div className="absolute top-2/4 left-2/4 hidden -translate-x-2/4 -translate-y-2/4 lg:block">
            <ul className="hidden lg:flex mb-4 mt-2 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center ">
              <div className="mr-4 hidden lg:block">{navList}</div>
            </ul>
          </div>
          <div className="flex items-center gap-4">
            <Button
              variant="gradient"
              size="sm"
              className="hidden lg:inline-block"
              ripple={true}
              onClick={goContact}
            >
              <span>{t("menu.contact")}</span>
            </Button>
            <div>
              {!showButton && (
                <Button
                  onClick={() => onClickLanguageChange("mn")}
                  size="sm"
                  variant="text"
                >
                  MN <img alt="" src={require("../assets/images/mn.png")} />{" "}
                </Button>
              )}
              {showButton && (
                <Button
                  onClick={() => onClickLanguageChange("en")}
                  size="sm"
                  variant="text"
                >
                  EN <img alt="" src={require("../assets/images/en.png")} />{" "}
                </Button>
              )}
            </div>

            <IconButton
              variant="text"
              className="ml-auto h-6 w-6 text-inherit hover:bg-transparent focus:bg-transparent active:bg-transparent lg:hidden"
              ripple={false}
              onClick={() => setOpenNav(!openNav)}
            >
              {openNav ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  className="h-6 w-6"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              )}
            </IconButton>
          </div>
        </div>
        <MobileNav open={openNav}>
          {navList}
          <Button variant="gradient" size="sm" fullWidth className="mb-2">
            <span>{t("menu.contact")}</span>
          </Button>
        </MobileNav>
      </Navbar>
      <MessengerCustomerChat
        pageId="1458770424191834"
        appId="3507716136156097"
      />
    </>
  );
}
